import { FileDownloadService } from "@topline/services/fileDownloadService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ToasterService } from "@topline/services/toasterService";
import { GridValueEditorService } from "../common/gridValueEditor/service/gridValueEditorService";

(module => {
    module.component("mktshSummary", {
        template: require("./mktshSummaryComponent.html"),
        bindings: {
            marketPmForecast: "<",
            marketStatisticalForecast: "<",
            historicalMarketValue: "<",
            brandPmForecast: "<",
            brandPmForecastAfterCorrection: "<",
            historicalBrandValue: "<",
            parameters: "<",
            showPeriodType: "<"
        },
        controller: [
            "$scope",
            angularServicesNames.$translate,
            "mktshSummaryCalculation",
            "$timeout",
            "calculationPPGService",
            "PPGChartAndTableService",
            ToasterService.componentName,
            FileDownloadService.componentName,
            "dtpChartService",
            GridValueEditorService.componentName,
            "FileSaver",
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                mktshSummaryCalculation: $TSFixMe,
                $timeout: ng.ITimeoutService,
                calculationPPGService: $TSFixMe,
                PPGChartAndTableService: $TSFixMe,
                toasterService: ToasterService,
                fileDownloadService: FileDownloadService,
                dtpChartService: $TSFixMe,
                gridValueEditorService: GridValueEditorService,
                FileSaver: $TSFixMe
            ) {
                var $ctrl = this;

                $scope.$on("chart-create", (e: $TSFixMe, chartInstance: $TSFixMe) => {
                    $ctrl.chartInstance = chartInstance;
                });

                $ctrl.showSlider = false;

                function refreshDebounce() {
                    if (angular.isDefined($scope.watchTimeout)) {
                        $timeout.cancel($scope.watchTimeout);
                    }
                    $scope.watchTimeout = $timeout(function () {
                        recalculateMktsh();
                    }, 300);
                }

                function recalculateMktsh() {
                    if (
                        !angular.isUndefinedOrNull($ctrl.historicalMarketValue) &&
                        !angular.isUndefinedOrNull($ctrl.marketPmForecast) &&
                        !angular.isUndefinedOrNull($ctrl.historicalBrandValue) &&
                        !angular.isUndefinedOrNull($ctrl.brandPmForecast)
                    ) {
                        const historicalBrandData = handleHistoricalBrandData($ctrl.historicalBrandValue);
                        const marketPM = $ctrl.historicalMarketValue.concat($ctrl.marketPmForecast);
                        const brandForecastPM = historicalBrandData.concat($ctrl.brandPmForecast);

                        const sumMarketYearlyPM = calculationPPGService.sumBy(
                            marketPM,
                            $ctrl.parameters.historicalDataStart,
                            (month: $TSFixMe) => month == 0
                        );
                        const sumBrandYearlyPM = calculationPPGService.sumBy(
                            brandForecastPM,
                            $ctrl.parameters.historicalDataStart,
                            (month: $TSFixMe) => month == 0
                        );
                        const sumMarketQuarterPM = calculationPPGService.sumBy(
                            marketPM,
                            $ctrl.parameters.historicalDataStart,
                            (month: $TSFixMe) => month % 3 == 0
                        );
                        const sumBrandQuarterPM = calculationPPGService.sumBy(
                            brandForecastPM,
                            $ctrl.parameters.historicalDataStart,
                            (month: $TSFixMe) => month % 3 == 0
                        );

                        $ctrl.mktshPm = mktshSummaryCalculation.calculateSumMktsh(sumBrandYearlyPM, sumMarketYearlyPM);
                        $ctrl.mktshPmQuarter = mktshSummaryCalculation.calculateSumMktsh(
                            sumBrandQuarterPM,
                            sumMarketQuarterPM
                        );
                        $ctrl.mktshPmMonthly = mktshSummaryCalculation.calculateSumMktsh(brandForecastPM, marketPM);

                        $ctrl.mkshrData = [
                            {
                                header: $translate.instant("FORECAST.CHART.PM_FORECAST"),
                                data: $ctrl.mktshPm
                            }
                        ];

                        $ctrl.dataToQuartersTable = [
                            {
                                header: $translate.instant("FORECAST.CHART.PM_FORECAST"),
                                data: $ctrl.mktshPmQuarter,
                                isPercentage: true
                            }
                        ];

                        $ctrl.monthlyMkshrGridOptions.gridData = [
                            {
                                header: "Mkshr",
                                values: $ctrl.mktshPmMonthly
                            }
                        ];

                        addMkshrAfterCorrectionToTables(
                            historicalBrandData,
                            sumMarketYearlyPM,
                            sumMarketQuarterPM,
                            marketPM
                        );
                        popualteChartDate();
                    }
                }

                function handleHistoricalBrandData(input: $TSFixMe) {
                    if (input.length == 0) {
                        return _.times($ctrl.historicalMarketValue.length, _.constant(null));
                    }
                    return input;
                }

                function addMkshrAfterCorrectionToTables(
                    historicalBrandData: $TSFixMe,
                    sumMarketYearlyPM: $TSFixMe,
                    sumMarketQuarterPM: $TSFixMe,
                    marketPM: $TSFixMe
                ) {
                    if ($ctrl.brandPmForecastAfterCorrection) {
                        const brandForecastPMAfterCorrection = $ctrl.brandPmForecastAfterCorrection
                            ? historicalBrandData.concat($ctrl.brandPmForecastAfterCorrection)
                            : null;

                        const sumAfterCorrectionYearlyPM = calculationPPGService.sumBy(
                            brandForecastPMAfterCorrection,
                            $ctrl.parameters.historicalDataStart,
                            (month: $TSFixMe) => month == 0
                        );
                        const sumAfterCorrectionQuarterPM = calculationPPGService.sumBy(
                            brandForecastPMAfterCorrection,
                            $ctrl.parameters.historicalDataStart,
                            (month: $TSFixMe) => month % 3 == 0
                        );

                        $ctrl.mktshPmAfterCorrection = mktshSummaryCalculation.calculateSumMktsh(
                            sumAfterCorrectionYearlyPM,
                            sumMarketYearlyPM
                        );
                        $ctrl.mktshPmQuarterAfterCorrection = mktshSummaryCalculation.calculateSumMktsh(
                            sumAfterCorrectionQuarterPM,
                            sumMarketQuarterPM
                        );
                        $ctrl.mktshPmMonthlyAfterCorrection = mktshSummaryCalculation.calculateSumMktsh(
                            brandForecastPMAfterCorrection,
                            marketPM
                        );

                        $ctrl.mkshrData.push({
                            header: $translate.instant("FORECAST.CHART.PM_FORECAST_AFTER_CORRECTION"),
                            data: $ctrl.mktshPmAfterCorrection
                        });

                        $ctrl.dataToQuartersTable.push({
                            header: $translate.instant("FORECAST.CHART.PM_FORECAST_AFTER_CORRECTION"),
                            data: $ctrl.mktshPmQuarterAfterCorrection,
                            isPercentage: true
                        });

                        $ctrl.monthlyMkshrGridOptions.gridData.push({
                            header: $translate.instant("FORECAST.CHART.PM_FORECAST_AFTER_CORRECTION"),
                            values: $ctrl.mktshPmMonthlyAfterCorrection
                        });
                    } else {
                        $ctrl.mktshPmAfterCorrection = null;
                        $ctrl.mktshPmQuarterAfterCorrection = null;
                        $ctrl.mktshPmMonthlyAfterCorrection = null;
                    }
                }

                $scope.$watchGroup(["$ctrl.parameters.historicalDataStart", "$ctrl.parameters.forecastEndDate"], () => {
                    if (!$ctrl.parameters || !$ctrl.parameters.historicalDataStart || !$ctrl.parameters.forecastEndDate)
                        return;

                    $ctrl.monthlyMkshrGridOptions.header = gridValueEditorService.prepareHeaderData(
                        $ctrl.parameters.historicalDataStart,
                        $ctrl.parameters.forecastEndDate
                    );
                });

                $scope.$watch("$ctrl.showPeriodType", () => {
                    if ($ctrl.mktshPm && $ctrl.mktshPmQuarter && $ctrl.mktshPmMonthly) {
                        popualteChartDate();
                    }
                });

                function popualteChartDate() {
                    if ($ctrl.showPeriodType === "years") {
                        $ctrl.chartData = _.filter([$ctrl.mktshPm, $ctrl.mktshPmAfterCorrection], (x: $TSFixMe) =>
                            angular.isArray(x)
                        );
                        $ctrl.labels = PPGChartAndTableService.prepareLabelsToPPG(
                            $ctrl.parameters.historicalDataStart,
                            $ctrl.parameters.forecastEndDate
                        );
                    } else if ($ctrl.showPeriodType === "quarters") {
                        $ctrl.chartData = _.filter(
                            [$ctrl.mktshPmQuarter, $ctrl.mktshPmQuarterAfterCorrection],
                            (x: $TSFixMe) => angular.isArray(x)
                        );
                        const quaterLabels = PPGChartAndTableService.prepareLabelsToQuartersTable(
                            $ctrl.parameters.historicalDataStart,
                            $ctrl.parameters.forecastEndDate
                        );

                        const lables = [];
                        for (const quaterLabel of quaterLabels) {
                            for (const q of quaterLabel.quarters) {
                                lables.push(`${q} - ${quaterLabel.year}`);
                            }
                        }
                        $ctrl.labels = lables;
                    } else if ($ctrl.showPeriodType === "months") {
                        $ctrl.chartData = _.filter(
                            [$ctrl.mktshPmMonthly, $ctrl.mktshPmMonthlyAfterCorrection],
                            (x: $TSFixMe) => angular.isArray(x)
                        );
                        $ctrl.labels = dtpChartService.preparePeriodsAndLabels(
                            $ctrl.parameters.historicalDataStart,
                            $ctrl.parameters.forecastEndDate
                        ).periods;
                    }

                    $ctrl.showSlider = true;
                    $timeout(function () {
                        $scope.$broadcast("rzSliderForceRender");
                    });
                }

                $ctrl.exportTable = function () {
                    toasterService.showReportGenerateBusyIndicator(
                        () =>
                            fileDownloadService.exportTable("table.xlsx", {
                                columns: $ctrl.labels,

                                rows: _.map($ctrl.mkshrData, (x: $TSFixMe) => {
                                    return {
                                        header: x.header,
                                        values: x.data,
                                        decimalPlaces: 2,
                                        isPercentage: true
                                    };
                                })
                            }),
                        "EXCEL_EXPORT_GENERATING",
                        "EXCEL_EXPORT_GENERATED"
                    );
                };

                $ctrl.exportChart = (event: $TSFixMe) => {
                    var canvas = $ctrl.chartInstance.chart.canvas;
                    canvas.toBlob(
                        function (blob: $TSFixMe) {
                            FileSaver.saveAs(blob, "wykres.png");
                        },
                        "image/png",
                        1
                    );
                };

                $scope.$on("LanguageChanged", () => resetChartTranslations());

                function resetChartTranslations() {
                    $translate(["FORECAST.CHART.PM_FORECAST_AFTER_CORRECTION"]).then(
                        (translations: $TSFixMe) =>
                            ($ctrl.series = ["Mktsh", translations["FORECAST.CHART.PM_FORECAST_AFTER_CORRECTION"]])
                    );
                }

                $ctrl.$onInit = () => {
                    resetChartTranslations();

                    $scope.$watch(
                        "$ctrl.brandPmForecast",
                        (newVal: $TSFixMe) => {
                            if (newVal) refreshDebounce();
                        },
                        true
                    );

                    $scope.$watch(
                        "$ctrl.historicalMarketValue",
                        (newVal: $TSFixMe) => {
                            if (newVal) refreshDebounce();
                        },
                        true
                    );
                    $scope.$watch(
                        "$ctrl.marketPmForecast",
                        (newVal: $TSFixMe) => {
                            if (newVal) refreshDebounce();
                        },
                        true
                    );

                    $scope.$watch(
                        "$ctrl.historicalBrandValue",
                        (newVal: $TSFixMe) => {
                            if (newVal) refreshDebounce();
                        },
                        true
                    );

                    $ctrl.monthlyMkshrGridOptions = {
                        gridName: "monthlyMkshr",
                        readOnly: true,
                        valuesSpecialEnd: "%",
                        valuesDecimalPlaces: 2
                    };
                };

                $ctrl.options = {
                    scales: {
                        yAxes: [
                            {
                                id: "y-value",
                                display: true,
                                position: "left",
                                ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: 100
                                }
                            }
                        ]
                    }
                };
                $ctrl.slider = {
                    options: {
                        floor: 0,
                        ceil: 100,
                        vertical: true,
                        showSelectionBar: true,
                        id: "mkshrSuggestetMaxSilder"
                    }
                };
                $ctrl.datasetOverride = [
                    {
                        type: "line",
                        fill: true,
                        borderColor: "rgba(128, 196, 194, 1)",
                        backgroundColor: "rgba(128, 196, 194, 0.5)"
                    },
                    {
                        type: "line",
                        fill: false
                    }
                ];
            }
        ]
    });
})(angular.module("topline.modules"));
